import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { ModelosVehiculoInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculo.interface";

export async function ToggleVisibilityModeloVehiculoAction(
  idModelo: string
): Promise<ApiResponse<ModelosVehiculoInterface>> {
  const { data } = await apiClient.patch<ModelosVehiculoInterface>(
    `gvModeloVehiculos/${idModelo}/toggleVisibility`
  );
  return {
    status: 200,
    data,
    message:
      "Visibilidad del Modelo de vehiculo actualizada correctamente",
  };
}
